import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class GroupsService {
  // region Atributos
  private API_URL = environment.url;
  // endregion

  // region Constructor
  constructor(private httpClient: HttpClient) {}
  // endregion

  //#region Métodos

  // Obtiene el listado de grupos
  getList(): Observable<any> {
    return this.httpClient.get<any>(`${this.API_URL}/group/index`).pipe(
      map((res) => {
        return res;
      })
    );
  }

  add(data): Observable<any> {
    return this.httpClient.post<any>(`${this.API_URL}/group/store`, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  addUserToGroup(data): Observable<any> {
    return this.httpClient.post<any>(`${this.API_URL}/user_group/store`, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  unlinkUserFromGroup(data): Observable<any> {
    return this.httpClient.post<any>(`${this.API_URL}/user_group/unlink_user`, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  update(id, data): Observable<any> {
    return this.httpClient.put<any>(`${this.API_URL}/group/rename/${id}`, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  delete(idgroup: number): Observable<any> {
    return this.httpClient
      .delete<any>(`${this.API_URL}/group/delete/${idgroup}`)
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  //#endregion
}
